module.exports = __webpack_public_path__ + "static/img/tow.db3d0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/radishImg/tow.png
// module id = eR+/
// module chunks = 1